import { fromJS } from 'immutable'
import {
  TEAM_LIST_REQUEST,
  TEAM_LIST_SUCCESS,
  TEAM_LIST_FAILURE,
  TEAM_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TEAM_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case TEAM_LIST_SUCCESS:
      return state
        .set('team', fromJS(action.payload.teams))
        .set('isFetching', false)
    case TEAM_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case TEAM_LIST_RESET:
      return state
        .set('redirect', false)
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/team/team-list-reducer.js